import widgetInfo from './widgetInfo';
import account from './account';
import wisVehicle from './wis-vehicle';
import pricingModuleData from './pricingModule';
import userProfile from './userProfile';
import shouldPortalPricing from './shouldPortalPricing';
import shouldFetchGMPayments from './shouldFetchGMPayments';
import isDREnabled from './isDREnabled';
import enableMyCars from './enableMyCars';

const root = {
	widgetInfo,
	account,
	pricingModuleData,
	userProfile,
	wisVehicle,
	shouldPortalPricing,
	shouldFetchGMPayments,
	isDREnabled,
	enableMyCars
};

export default root;
